import { externalCatalogs } from './external-catalogs-en.i18n';

export const en = {
  externalCatalogs,
};
